var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPortfolioA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "My Portfolio"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7067 2.68899C15.7067 1.36814 14.6335 0.294922 13.3127 0.294922H5.00217C3.68132 0.294922 2.60259 1.36814 2.60259 2.68899V10.9995C2.60259 11.4728 2.74018 11.9131 2.98785 12.2873L9.61972 6.21683C10.7755 5.16562 12.4761 5.05554 13.7529 5.94712L15.7067 7.30103V2.68899ZM6.68077 6.31038C5.61306 6.31038 4.74902 5.4408 4.74902 4.37309C4.74902 3.30539 5.61306 2.43584 6.68077 2.43584C7.74847 2.43584 8.61806 3.30539 8.61806 4.37309C8.61806 5.4408 7.74847 6.31038 6.68077 6.31038ZM11.0014 15.7052H2.69094C1.37009 15.7052 0.296875 14.632 0.296875 13.3111V5.00068C0.296875 4.11461 0.781197 3.33307 1.50217 2.92581V10.9997C1.50217 12.9314 3.07069 14.5 5.00247 14.5H13.0818C12.669 15.2209 11.8875 15.7052 11.0014 15.7052ZM5.84995 4.37289C5.84995 3.91061 6.22419 3.53636 6.68097 3.53636C7.14329 3.53636 7.51753 3.91061 7.51753 4.37289C7.51753 4.83521 7.14329 5.20946 6.68097 5.20946C6.22419 5.20946 5.84995 4.83521 5.84995 4.37289ZM3.77534 13.0524L10.3632 7.0314C11.1337 6.32692 12.2674 6.25537 13.126 6.84977L15.7072 8.63845V10.9995C15.7072 12.3204 14.634 13.3991 13.3131 13.3991H5.00264C4.55685 13.3991 4.13305 13.2725 3.77534 13.0524Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolioA);
export default __webpack_public_path__ + "static/media/portfolio_a.b5696edf0ead97bc3e591863c28d6954.svg";
export { ForwardRef as ReactComponent };